import { HeaderPageTitle } from 'src/context/header-title.context';
import type { ReactNode } from 'react';
import { Outlet } from '@tanstack/react-router';
import {
  SettingsLayout,
  type SettingsRailGroup,
} from '@/components/settings/SettingsLayout';
import {
  ORGANIZATION_SETTINGS_GROUPS,
  sectionPath,
} from './organizationSettingsSections';
import { useVisibleOrganizationSettingsSections } from './useVisibleOrganizationSettingsSections';
import { T } from 'gt-react';

export function SettingsOrganizationLayoutPage({
  children,
  hideRail,
}: {
  children?: ReactNode;
  hideRail?: boolean;
} = {}) {
  const sections = useVisibleOrganizationSettingsSections();

  const groups: SettingsRailGroup[] = ORGANIZATION_SETTINGS_GROUPS.map(
    (group) => {
      const items: SettingsRailGroup['items'] = [];
      for (const s of sections) {
        if (s.group !== group.id) continue;
        items.push({
          id: s.id,
          title: s.title,
          keywords: s.subtitle,
          icon: s.icon,
          to: sectionPath(s.id),
        });
      }
      return { id: group.id, title: group.title, items };
    },
  );

  return (
    <>
      {/* Wrapped pages (task types) render under this same route match and
          title the crumb themselves; a second title would share its slot. */}
      {!children && (
        <HeaderPageTitle>
          <T>Organization Settings</T>
        </HeaderPageTitle>
      )}
      <SettingsLayout groups={groups} hideRail={hideRail}>
        {children ?? <Outlet />}
      </SettingsLayout>
    </>
  );
}
